import { fromJS } from 'immutable';

export default {
    setSDM20LHTs: (state, products) => {
        return state.setIn(['list'], fromJS(products)).set('initialized', true);
    },
    updateSDM20LHTs: (state, products) => {
        return state.mergeIn(['list'], fromJS(products));
    },
    setSDM20LHTDetails: (state, productId, product) => {
        return state.setIn(['list', productId], fromJS(product));
    },
    updateSDM20LHTStatus: (state, productId, status) => {
        return state.setIn(['list', productId, 'state'], status);
    },
    switchSDM20LHTMaster: (state, productId, masterId) => {
        return state.setIn(['list', productId, 'userMasterId'], masterId);
    },
    dissociateUserFromSDM20LHT: (state, productId, userId) => {
        if (state.getIn(['list', productId, 'userMasterId']) === userId) {
            state = state.deleteIn(['list', productId, 'userMasterId']);
        }
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    },
    dissociateUserFromSDM20LHTAndSwitchMaster: (state, productId, userId, masterId) => {
        state = state.setIn(['list', productId, 'userMasterId'], masterId);
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM20LHT/core.js